{
  "version": 1,
  "asset_id": "42069d52-985b-497f-a002-0ae602963106",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/42069d52-985b-497f-a002-0ae602963106/campsite-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/42069d52-985b-497f-a002-0ae602963106/campsite-hero.webp",
  "original_filename": "campsite-hero.webp",
  "size": 57992,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:32Z"
}
